import { Card, Flex, Heading, Text } from "@radix-ui/themes";
import { FC } from "react";

export const Error: FC = () => {
  return (
    <Flex align="center" justify="center" px="4" style={{ minHeight: "40vh" }}>
      <Card
        size="3"
        role="alert"
        aria-live="assertive"
        style={{ maxWidth: 680, width: "100%" }}
      >
        <Flex direction="column" gap="2" align="center">
          <Heading as="h1" size="6" align="center">
            Hinweis
          </Heading>
          <Text as="p" size="3" align="center">
            Zu dieser Bestellnummer können aktuell keine Details angezeigt
            werden.
          </Text>
        </Flex>
      </Card>
    </Flex>
  );
};
